'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Loading } from './lib/Loading'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Accordion } from './lib/Accordion'
import { SkillBlock } from './lib/SkillBlock'
import { MomentumScroll } from './lib/MomentumScroll'
import { KvSound } from './lib/KvSound'
import { HeaderSize } from './lib/HeaderSize'
import { CurriculumSlider } from './lib/CurriculumSlider'
import { Concept } from './lib/Concept'
// import { Produced } from './lib/Produced'

// new CookiePolicy('optout')
new Loading()
new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Accordion()
new SkillBlock()
new MomentumScroll()
new KvSound()
new HeaderSize()
new CurriculumSlider()
new Concept()
// new Produced()
